import { fetchBody } from '../../../../../../util/service';

// catalogAdvancedLicense is the license for the CATALOGSERVICESADV license.
const catalogAdvancedLicenseName = '998';
let licenseCheckSucceeded = false;
let catalogAdvancedLicensed = false;

// ResetLicenseCheck clears the cached license check result.
export const ResetLicenseCheck = () => {
  licenseCheckSucceeded = false;
  catalogAdvancedLicensed = false;
};

// IsCatalogAdvancedLicensed determines if
// CATALOGSERVICESADV is available in the license service.
export const IsCatalogAdvancedLicensed = async () => {
  if (licenseCheckSucceeded) {
    return catalogAdvancedLicensed;
  }
  try {
    await fetchBody({
      method: 'GET',
      url: `/licenses/products/${catalogAdvancedLicenseName}`
    });
    licenseCheckSucceeded = true;
    catalogAdvancedLicensed = true;
  } catch (error) {
    if (error.response.status === 404) {
      licenseCheckSucceeded = true;
      catalogAdvancedLicensed = false;
    } else {
      licenseCheckSucceeded = false;
      catalogAdvancedLicensed = false;
    }
  }
  return catalogAdvancedLicensed;
};
//# sourceMappingURL=registeredFeatures.js.map